const cssIf = ( param, value, elsevalue = "" ) => param ? value : elsevalue;
export default cssIf;